import { render } from "./EventView.vue?vue&type=template&id=683fa9d2&ts=true"
import script from "./EventView.vue?vue&type=script&lang=ts"
export * from "./EventView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__